<template>
  <v-container class="event-page text-left px-0 py-0" v-if="!!event.title">
    <v-layout row wrap>
      <v-flex md6 offset-sm0 xs12 class="pt-5 px-4">
        <h1 class="mb-3 d-inline">{{ event.title }}</h1>&nbsp;
        <h3 class="mb-3 d-inline">at {{ event.eventLocation }}</h3>

        <p>{{ formatDate }}</p>

        <small class="primary--text"><strong>About {{ event.title }}</strong></small>
        <p>{{ event.eventDescription }} </p>
        <p>{{ event.tdInvolvement }} </p>

        <v-btn
          :href="event.externalUrl"
          target="_blank"
          class="ml-0 mt-3"
          color="primary"
        >
          More Info
        </v-btn>
      </v-flex>
      <v-flex md6 offset-sm0 xs12 class="py-5 px-4 text-sm-right">
        <v-carousel class="primary">
          <v-carousel-item v-if="event.imageFeatured">
            <div
              :style="{'backgroundImage': `url(${event.imageFeatured})`}"
              class="bg-contain w-100 h-100"
            ></div>
          </v-carousel-item>
          <v-carousel-item
            v-for="image in event.imageGallery"
            :key="image"
            class="center-content"
          >
            <div
              :style="{'backgroundImage': `url(${image})`}"
              class="bg-contain w-100 h-100"
            ></div>
          </v-carousel-item>
        </v-carousel>
      </v-flex>

      <!-- <v-flex md6 offset-sm0 xs12 class="pt-5 px-4">

      </v-flex> -->

    </v-layout>
  </v-container>
</template>

<style lang="scss">
.center-content {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
}
</style>

<script>
import Vue from 'vue'
import { db, FieldValue } from '@/db.js'
import { formatDate } from '@/util'

export default {
  name: 'event',
  components: {
  },
  data () {
    return {
      event: {
        title: '',
        imageGallery: []
      },
      uri: this.$route.params.id,
      pageNotFound: false,
      clapCount: 0
    }
  },
  metaInfo () {
    return {
      title: this.event.title,
      meta: [
        { vmid: 'description', name: 'description', content: 'bar' }
      ]
    }
  },
  methods: {
    uriDecode: function (message) {
      return decodeURIComponent(message)
    },
    navSetTransparent () {
      this.$store.dispatch('navSetTransparent')
    }
  },
  computed: {
    transparent () {
      return this['$store'].state.navIsTransparent
    },
    formatDate () {
      return formatDate(this.event.start, this.event.end)
    }
  },
  mounted () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', true)
      this.$store.dispatch('navSetDark', false)
    }
  },
  beforeDestroy () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', false)
      this.$store.dispatch('navSetDark', true)
    }
  },
  firestore () {
    return {
      event: db.collection('events').doc(
        decodeURI(
          window.location.pathname.split('/').slice(-1)[0]
        )
      )
    }
  }
}
</script>
